import { http } from '@pendo/http';
const feedbackSuperApi = '/api/super/ss/_SNAME_/feedback';
const feedbackApi = '/api/s/_SID_/feedback';
import { replaceSNAME } from '@utils/http';

export function fetchVendors () {
    return http.get(`${feedbackSuperApi}/vendors`);
}

export function fetchProducts ({ vendorUuid }) {
    return http.get(`${feedbackSuperApi}/vendors/${vendorUuid}/products`);
}

export function fetchPermissionGroups () {
    return http.get(`${feedbackApi}/vendor/permissiongroups`);
}

export async function fetchPermissionGroupsForSub (subId) {
    const result = await http.get(`/api/s/${subId}/feedback/vendor/permissiongroups`);

    return result.data;
}

export function fetchVendorUsers ({ vendorUuid }) {
    return http.get(`${feedbackSuperApi}/vendors/${vendorUuid}/users`);
}

export function linkSubscriptionToVendor ({ vendorUuid }) {
    return http.post(`${feedbackSuperApi}/link/vendor/${vendorUuid}`);
}

export function unLinkSubscriptionToVendor () {
    return http.post(`${feedbackSuperApi}/unlink/vendor`);
}

export function linkModelsInVendor ({ vendorUuid, modelsToLink }) {
    return http.put(`${feedbackSuperApi}/link/vendor/${vendorUuid}`, modelsToLink);
}

export function unLinkModelsInVendor ({ modelsToUnLink }) {
    return http.put(`${feedbackSuperApi}/unlink/vendor`, modelsToUnLink);
}

export function autoCreateVendorUsers ({ usersToCreate, vendorUuid }) {
    return http.post(`${feedbackApi}/vendor/${vendorUuid}/vendorusers`, usersToCreate);
}

export function autoCreateProducts ({ productsToCreate, vendorUuid }) {
    return http.post(`${feedbackApi}/vendor/${vendorUuid}/products`, productsToCreate);
}

export function autoCreateVendor () {
    return http.post(`${feedbackSuperApi}/vendor`, {});
}

export function migrateGroupsToVendor ({ vendorUuid }) {
    return http.post(`${feedbackSuperApi}/vendor/${vendorUuid}/groups/migrate`, {});
}

export function autoSetupFeedback ({ applicationIds, subscriptionName }) {
    // replace name here since this is used in a super, non-impersonation view
    return http.post(replaceSNAME(`${feedbackSuperApi}/autoconfigure`, subscriptionName), { applicationIds });
}

export function fetchSigningKeys ({ vendorUuid }) {
    return http.get(`${feedbackSuperApi}/vendor/${vendorUuid}/signingkeys`);
}

export function syncSigningKeys ({ vendorUuid }) {
    return http.post(`${feedbackSuperApi}/vendor/${vendorUuid}/signingkeys/sync`);
}
